"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioLabelText = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _formInputTheme = require("../../textinput/styled/formInputTheme");
var _radioTheme = require("./radioTheme");
const getFontWeight = _ref => {
  let {
    isChecked,
    isDisabled,
    themeMode
  } = _ref;
  if (!isDisabled && isChecked) {
    return _radioTheme.radioLabelTheme.fontWeight.checked(themeMode);
  } else {
    return _radioTheme.radioLabelTheme.fontWeight.unchecked(themeMode);
  }
};
const RadioLabelText = (0, _styled.default)("div")`
    margin-left: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _radioTheme.radioLabelTheme.gap(themeMode);
}};
    margin-top: ${_ref3 => {
  let {
    size,
    themeMode
  } = _ref3;
  return _radioTheme.radioLabelTheme.marginTop[size](themeMode);
}};

    color: ${_ref4 => {
  let {
    isDisabled,
    themeMode
  } = _ref4;
  return isDisabled ? _radioTheme.radioLabelTheme.color.disabled(themeMode) : _radioTheme.radioLabelTheme.color.rest(themeMode);
}};
    font-size: ${_ref5 => {
  let {
    themeMode
  } = _ref5;
  return _formInputTheme.formInputTheme.fontSize.box(themeMode);
}};
    font-weight: ${getFontWeight};
    user-select: none;
`;
exports.RadioLabelText = RadioLabelText;
//# sourceMappingURL=RadioLabelText.js.map